import React from "react";
import { Row, Col, Timeline, Divider, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { useProjectState } from "../../../context/stateContext";
import tableNameImg from "../../../assets/images/table.png";
import totalAmountImg from "../../../assets/images/totalAmount.png";
import waiterNameImg from "../../../assets/images/waiter.png";
import countOrdersImg from "../../../assets/images/orderCount.png";
import minutesImg from "../../../assets/images/minutes.png";
import idImage from "../../../assets/images/id.png";

const TableInfoModalContent = () => {
  const {
    openTime,
    closeTime,
    ordersCount,
    duration,
    waiterName,
    tableName,
    billAmount,
    billId,
  } = useProjectState();

  const { bill, billDetailsLoading } = useSelector(
    (state) => state.tablesInfoReducer
  );

  const formattedDuration = Math.round(duration / 60);

  let openTimeBills = [];
  let otherBills = [];
  if (bill[0]?.orders !== undefined) {
    for (let item of bill[0].orders) {
      if (item.time === openTime) {
        openTimeBills.push(item);
      } else {
        const key = item.time.split("T")[1]?.split(".")[0];
        otherBills[key] = otherBills[key] || [];
        otherBills[key].push(item);
      }
    }
  }

  const sortedotherBills = Object.keys(otherBills)
    .sort((a, b) => {
      const timeA = new Date(`1970-01-01T${a}`);
      const timeB = new Date(`1970-01-01T${b}`);
      return timeA - timeB;
    })
    .reduce((sortedObj, key) => {
      sortedObj[key] = otherBills[key];
      return sortedObj;
    }, {});

  return (
    <>
      <div className="table-info-modal-content-container">
        <Row>
          <Col span={12} className="table-info-modal-content-first-col">
            <Tooltip placement="right" title="Сервитьор">
              <img src={waiterNameImg} alt="waiterNameImg" width="20px" />
            </Tooltip>
            <b>{waiterName}</b>
          </Col>
          <Col span={12} className="table-info-modal-content-second-col">
            <Tooltip placement="right" title="ID на сметката">
              <img src={idImage} alt="waiterNameImg" width="20px" />
            </Tooltip>
            <b>{billId}</b>
          </Col>
        </Row>

        <Row>
          <Col className="table-info-modal-content-first-col" span={12}>
            <Tooltip placement="right" title="Име на маса">
              <img src={tableNameImg} alt="tableNameImg" width="20px" />
            </Tooltip>
            <b>{tableName}</b>
          </Col>

          <Col className="table-info-modal-content-second-col" span={12}>
            <Tooltip placement="right" title="Времетраене">
              <img src={minutesImg} alt="minutesImg" width="20px" />
            </Tooltip>
            <b>{formattedDuration} мин</b>
          </Col>
        </Row>

        <Row>
          <Col className="table-info-modal-content-first-col" span={12}>
            <Tooltip placement="right" title="Брой поръчки">
              <img src={countOrdersImg} alt="countOrdersImg" width="20px" />
            </Tooltip>
            <b>{ordersCount}</b>
          </Col>

          <Col className="table-info-modal-content-second-col" span={12}>
            <Tooltip placement="right" title="Обща сума">
              <img src={totalAmountImg} alt="totalAmountImg" width="20px" />
            </Tooltip>
            <b>
              {(Math.round(parseFloat(billAmount) * 100) / 100).toFixed(2)} €
            </b>
          </Col>
        </Row>

        <Divider className="table-info-modal-content-divider" />
      </div>
      <div className="table-info-modal-content-timeline">
        <Timeline
          pending={billDetailsLoading && "Loading..."}
          items={
            !billDetailsLoading && [
              {
                style: { padding: 0 },
                color: "green",
                children: (
                  <>
                    <p>
                      <b>
                        {openTime.split("T")[1]?.split(".")[0]} Отваряне на
                        сметка{" "}
                      </b>
                    </p>
                    {openTimeBills.map((bill, index) => (
                      <p key={`bill-${index}`}>
                        {parseFloat(bill.quantity).toFixed(2)} x{" "}
                        {parseFloat(bill.price).toFixed(2)}€ - {bill.itemName}
                      </p>
                    ))}
                  </>
                ),
              },
              ...Object.keys(sortedotherBills).map((key) => ({
                style: { padding: 0 },
                color: "gray",
                children: (
                  <>
                    <p>
                      <b>{key} Добавяне към сметка </b>
                    </p>
                    {sortedotherBills[key].map((bill, index) => (
                      <p key={`bill-${index}`}>
                        {parseFloat(bill.quantity).toFixed(2)} x{" "}
                        {parseFloat(bill.price).toFixed(2)}€ - {bill.itemName}
                      </p>
                    ))}
                  </>
                ),
              })),
              closeTime == null
                ? ""
                : {
                    style: { padding: 0 },
                    color: "red",
                    children: (
                      <p>
                        <b>
                          {closeTime?.split("T")[1]?.split(".")[0]} Закриване на
                          сметка{" "}
                        </b>
                      </p>
                    ),
                  },
            ]
          }
        />
      </div>
    </>
  );
};

export default TableInfoModalContent;
